import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { FaChevronLeft } from "react-icons/fa";
import { IoBagCheck } from "react-icons/io5";
import { Link } from "react-router-dom";
import { CartContext } from "../../../contexts/MiniStore/CartContext";

const OrderSummary = ({ theme }) => {
  const { subTotal, total, cartTax, currency } = useContext(CartContext);
  useEffect(() => {
    // console.log("subTotal, total", subTotal, total);
  }, [subTotal, total]);
  return (
    <OrderSummaryWrapper theme={theme}>
      <SummaryTitle>Order Summary</SummaryTitle>
      <CharacterLine />
      <OrderDetails>
        <DetailKey>Subtotal</DetailKey>
        <SubtotalValue>{subTotal}</SubtotalValue>
      </OrderDetails>
      <OrderDetails>
        <DetailKey>Taxes</DetailKey>
        <SubtotalValue>
          {currency} {cartTax}
        </SubtotalValue>
      </OrderDetails>
      <OrderDetails>
        <DetailKey>Shipping</DetailKey>
        <ShippingValue theme={theme}>Calculated at Checkout</ShippingValue>
      </OrderDetails>
      <OrderTotal theme={theme}>
        <TotalKey theme={theme}>Total</TotalKey>
        <TotalValue theme={theme}>{total}</TotalValue>
      </OrderTotal>
      <ContinueShopping theme={theme} to="/storefront/shop">
        <FaChevronLeft />
        <span>Continue Shopping</span>
      </ContinueShopping>
      <Checkout theme={theme} to="/storefront/checkout">
        <IoBagCheck />
        Checkout
      </Checkout>
    </OrderSummaryWrapper>
  );
};

export default OrderSummary;

const OrderSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  flex: 0 0 calc(30% - 10px);
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
`;
const SummaryTitle = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #666666;
`;
const CharacterLine = styled.div`
  border: 1px solid #9c9a9a;
  background: #9c9a9a;
  width: 100%;
  height: 2px;
  border-width: 1px;
  margin: 10px 0px 22px 0px;
`;
const OrderDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 5px;
`;
const DetailKey = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #292727;
`;
const SubtotalValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: #666666;
`;
const ShippingValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.primaryColor.primary};
  text-align: end;
  // max-width: 50px;
`;
const OrderTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 40px 0px 10px 0px;
  padding: 1.5rem;
  background: #fff;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
`;
const TotalKey = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const TotalValue = styled.div`
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  color: ${({ theme }) => theme.primaryColor.primary};
`;
const ContinueShopping = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 10px 0px;
  padding: 1.5rem;
  cursor: pointer;
  text-decoration: none !important;
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  background: ${({ theme }) => theme.textColor.primary};
  color: ${({ theme }) => theme.primaryColor.primary} !important;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  overflow: hidden;

  svg {
    color: ${({ theme }) => theme.primaryColor.primary};
    margin: 0px 3px;
    flex-shrink: 0;
  }

  // Add span to wrap text
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    line-height: 30px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;

const Checkout = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 65px;
  border-radius: 0.15rem;
  border-width: 1px;
  border: 1px solid #dee2e6;
  margin: 10px 0px;
  padding: 1.5rem;
  cursor: pointer;
  text-decoration: none !important;
  font-family: Outfit, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 20px;
  background: ${({ theme }) => theme.primaryColor.primary};
  color: ${({ theme }) => theme.textColor.primary} !important;
  // box-shadow: ${({ theme }) => theme.boxShadow.primary};
  svg {
    color: ${({ theme }) => theme.textColor.primary};
    margin: 0px 3px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;
